import MFAccordion from './MFAccordion'
import RenderHTML from './RenderHTML'

type FAQItemProps = {
  title: string
  description: string
  isExpanded: boolean
  onAccordionClick: () => void
  titleClassName?: string
  accordionHeaderClassName?: string
  accordionBodyClassName?: string
}

export const FAQItem = ({
  title,
  description,
  isExpanded,
  onAccordionClick,
  titleClassName,
  accordionHeaderClassName = '!px-4 !py-3 !text-[13px] !min-h-12',
  accordionBodyClassName = '!px-4 !text-[13px] max-w-[90%]'
}: FAQItemProps) => {
  return (
    <div className='bg-white'>
      <MFAccordion
        title={title}
        accordionHeaderClassName={accordionHeaderClassName}
        accordionBodyClassName={accordionBodyClassName}
        middleContentTitleClassName={titleClassName ?? ''}
        isExpanded={isExpanded}
        onAccordionClick={onAccordionClick}
      >
        <div onClick={onAccordionClick} className='text-[#6A6E6E] text-[13px] leading-[150%] pb-4 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:my-1 [&_li]:mb-0.5'>
          <RenderHTML innerHTMLText={description} />
        </div>
      </MFAccordion>
    </div>
  )
}
